var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3976,
    cy: 50.3998,
    r: 50.3998,
    fill: "#FAD414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3978 0C22.5623 0 -0.00219727 22.5645 -0.00219727 50.4C-0.00219727 78.2355 22.5623 100.8 50.3978 100.8C78.2333 100.8 100.798 78.2355 100.798 50.4C100.798 22.5645 78.2333 0 50.3978 0ZM62.3363 34.8285H54.7606C53.8628 34.8285 52.8653 36.0098 52.8653 37.5795V43.05H62.3416L60.9083 50.8515H52.8653V74.2718H43.9246V50.8515H35.8133V43.05H43.9246V38.4615C43.9246 31.878 48.4921 26.5283 54.7606 26.5283H62.3363V34.8285Z",
    fill: "#FE42FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.9e44d347625d4ae0037e84599763f436.svg";
export { ForwardRef as ReactComponent };